module.exports = "/assets/dist/images/video_background.jpg?d6de7478d1717a7ffdca632707074170";